import React, { useEffect, useState } from "react";
import PlaceholderWithBGFilled from "assets/img/Placeholder_with_BG_filled.svg";
import PlayButton from "assets/img/play-button.svg";
import MediaDisplay from "./MediaDisplay";

const MediaContainer = ({ attachment, media_type, containerStyle = {} }) => {
  const [mediaSrc, setMediaSrc] = useState(PlaceholderWithBGFilled);
  const [mediaStyle, setMediaStyle] = useState();

  const audioStyle = {
    position: "absolute",
    width: " 20px",
    height: "unset",
    objectFit: "unset",
  };

  useEffect(() => {
    if (!media_type) {
      return;
    }

    if ([2, 3].includes(media_type)) {
      setMediaSrc(attachment);
      return;
    }
    if (media_type === 4) {
      setMediaSrc(PlayButton);
      setMediaStyle({ ...audioStyle, ...containerStyle });
    }
    //eslint-disable-next-line
  }, [media_type]);

  return (
    <MediaDisplay
      src={mediaSrc}
      mediaType={media_type}
      alt={"pollImage"}
      mediaStyle={mediaStyle}
    />
  );
};

export default MediaContainer;
